import React, { useState } from "react";
import { signInWithEmailAndPassword } from "firebase/auth";
import { auth } from "/Users/noshadboksh/FINALYEAR/react-schedule/src/firebase.js";
import { useNavigate } from "react-router-dom";
import { useTasks } from 'components/Schedule/TaskContext';
import "../AuthFormStyles.css";
import Header from './Header'; // Import the Header component
import { useNightMode } from '../NightModeContext'; // Make sure this path is correct

const SignIn = () => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const { setUser } = useTasks();
    const [error, setError] = useState('');
    const navigate = useNavigate();
    const { isNightMode, toggleNightMode } = useNightMode();

    const onSignIn = (e) => {
        e.preventDefault();
        if (!email || !password) {
            setError('Fields cannot be blank');
            return;
        }
        signInWithEmailAndPassword(auth, email, password)
            .then((userCredential) => {
                setUser(userCredential.user); // First, set the user
                setError('');
                navigate("/home"); // Then navigate to the home page
            }).catch((error) => {
                console.error(error);
                setError(error.message);
            });
    };

    return (
        <>
            <Header isNightMode={isNightMode} toggleNightMode={toggleNightMode} /> {/* Include the Header component */}
            <div className="card">
                <form onSubmit={onSignIn}>
                    <h1>Log In</h1>
                    {error && <p className="error-message">{error}</p>}
                    <input
                        type="email"
                        placeholder="Email"
                        className="auth-input"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                    />
                    <input
                        type="password"
                        placeholder="Password"
                        className="auth-input"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                    />
                    <div className="button-container">
                        <button type="submit" className="auth-button">Log In</button>
                        <button type="button" onClick={() => navigate("/signup")} className="switch-button">Sign Up</button>
                    </div>
                </form>
            </div>
        </>
    );
};

export default SignIn;
